import HelpPage from "./lib/help-page/HelpPage";
export * from "./lib/help-page/HelpPageProps";
export default HelpPage;
